











import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class NominateInput extends Vue {
  @Prop(String) public label!: string;
  @Prop() public options!: any[];
  private selectedOption: any[] = [];

  get selected() {
    return this.selectedOption;
  }

  set selected(_selected: any[]) {
    this.selectedOption = _selected;
    this.$emit('input', _selected);
  }
}
